import api from "../libs/api";

export default {
  // =========================
  // ID-based routes
  // =========================
  getForms: () =>
    new Promise((resolve, reject) => {
      api()
        .get("/dynamic-forms")
        .then(({ status, data }) =>
          status === 200 ? resolve(data) : reject(`Failed with status: ${status}`)
        )
        .catch((err) => reject(err));
    }),

  createForm: (data) =>
    new Promise((resolve, reject) => {
      api()
        .post("/dynamic-forms", data)
        .then(({ status, data }) =>
          status === 200 ? resolve(data) : reject(`Failed with status: ${status}`)
        )
        .catch((err) => reject(err));
    }),

  getFormRecords: (id) =>
    new Promise((resolve, reject) => {
      api()
        .get(`/dynamic-forms/${id}/records`)
        .then(({ status, data }) =>
          status === 200 ? resolve(data) : reject(`Failed with status: ${status}`)
        )
        .catch((err) => reject(err));
    }),

  addRecord: (id, data) =>
    new Promise((resolve, reject) => {
      api()
        .post(`/dynamic-forms/${id}/records`, data)
        .then(({ status, data }) =>
          status === 200 ? resolve(data) : reject(`Failed with status: ${status}`)
        )
        .catch((err) => reject(err));
    }),

  deleteForm: (id) =>
    new Promise((resolve, reject) => {
      api()
        .delete(`/dynamic-forms/${id}`)
        .then(({ status, data }) =>
          status === 200 ? resolve(data) : reject(`Failed with status: ${status}`)
        )
        .catch((err) => reject(err));
    }),

  // =========================
  // SLUG-based routes
  // =========================
  getFormBySlug: (slug) =>
    new Promise((resolve, reject) => {
      api()
        .get(`/dynamic-forms/slug/${slug}`)
        .then(({ status, data }) =>
          status === 200 ? resolve(data) : reject("Form not found")
        )
        .catch((err) => reject(err));
    }),

  submitFormBySlug: (slug, data) =>
    new Promise((resolve, reject) => {
      // If `id` exists, update record
      if (data.id) {
        api()
          .put(`/dynamic-forms/slug/${slug}`, data)
          .then(({ status, data }) => {
            if (status === 200) resolve(data);
            else reject("Failed to update record");
          })
          .catch((err) => reject(err));
      } else {
        // Otherwise, create new record
        api()
          .post(`/dynamic-forms/slug/${slug}`, data)
          .then(({ status, data }) => {
            if (status === 200 || status === 201) resolve(data);
            else reject("Failed to save form");
          })
          .catch((err) => reject(err));
      }
    }),

  // =========================
  // Get slug-wise records with filters & pagination
  // =========================
  getFormRecordsBySlug: (slug, params = {}) =>
    new Promise((resolve, reject) => {
      api()
        .get(`/dynamic-forms/slug/${slug}/records`, { params })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject(`Failed to fetch records for ${slug}`);
        })
        .catch((err) => reject(err));
    }),

  addRecordBySlug: (slug, data) =>
    new Promise((resolve, reject) => {
      api()
        .post(`/dynamic-forms/slug/${slug}/records`, data)
        .then(({ status, data }) => {
          if (status === 200 || status === 201) resolve(data);
          else reject("Failed to add record");
        })
        .catch((err) => reject(err));
    }),

  // =========================
  // NEW: Fetch single record by ID for editing
  // =========================
  getRecordById: (slug, id) =>
    new Promise((resolve, reject) => {
      api()
        .get(`/dynamic-forms/slug/${slug}/records/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          else reject("Record not found");
        })
        .catch((err) => reject(err));
    }),
};
